
import { MultiSelect } from 'primereact/multiselect';
import DatePicker from 'react-multi-date-picker';
import { SkeletonDataTable } from '../Loader/Loader';
import { useSubmitTimesheet } from '../../Hooks/Features/Timesheet/useSubmitTimesheet';
import PanelHeaderTemplate from '../CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate';
import { AgGridReact } from '@ag-grid-community/react';
import CommonFilterDropdown from '../CommonCompo/CommonFilterDropdown/CommonFilterDropdown';

const PenddingTimeSheetList = (props) => {
    const { getPendingTimesheet, loader, timesheetPendingData, colDefs, filterValues, setFilterValues } = useSubmitTimesheet(props);

    return (
        <div className='w100 mt-1'>
            <div className='d-flex justify-content-between gap-4'>
                <div className='d-flex gap-4 w-75'>
                    <div className=''>
                        <DatePicker value={filterValues?.date} onChange={(e) => setFilterValues((prev) => ({ ...prev, date: e, isChange: true }))} range rangeHover placeholder="Select Dates" onClose={() => { if (filterValues?.isChange) { getPendingTimesheet(); } }} />
                    </div>
                    <div className='w30'>
                        <CommonFilterDropdown fields={[{ key: "users", label: "Users", col: 12 }]} filterValues={filterValues} setFilterValues={setFilterValues} />
                    </div>
                </div>
                {/* {
                    timesheetPendingData?.length > 0 && <div className=''>
                        <button onClick={() => addRemark()}>Submit</button>
                    </div>
                } */}
            </div>
            {
                loader ? <div className='my-3 w100'>
                    <SkeletonDataTable numSkeletons={10} />
                </div> : timesheetPendingData.length > 0 && <div className="ag-theme-alpine mt-1" style={{ height: "50vh", width: '100%' }}>
                    <AgGridReact columnDefs={colDefs} rowData={timesheetPendingData} rowHeight={30} headerHeight={30} />
                </div>
            }
        </div>
    )
}

export default PenddingTimeSheetList
